<i18n>
{
"en": {
  "BUSES": "Buses",
  "MANAGEBUS": "Manage Bus",
  "BUSNUMBER": "Bus Number",
  "MAKE": "Make",
  "MODEL": "Model",
  "YEAR": "Year",
  "PLATENUMBER": "Plate Number",
  "SEATINGCAPACITY": "Seating Capacity",
  "EXPIRATIONDATE": "Expiration Date",
  "DOCUMENTS": "Documents",
  "REGISTRATIONEXPIRATIONDATE": "Registration Expiration Date",
  "LABEL": "Label",
  "EDITBUS": "Edit Bus",
  "VIEW": "View",
  "LOADING": "Loading...",
  "PICKADATE": "Pick a date",
  "PICKAYEAR": "Pick a year",
  "DROPFILEHEREOR": "Drop file here or",
  "CLICKTOUPLOAD": "click to upload",
  "JPGPNGFILES": "jpg/png files with a size less than 400kb",
  "REGISTRATION": "Registration",
  "INSURANCE": "Insurance",
  "OTHER": "Other",
  "DOCUMENTTYPE": "Document Type",
  "NAME": "Name",
  "FILE": "File",
  "PREVIEW": "Preview",
  "DELETEDOCUMENT": "Delete Document",
  "TRIPS": "Trips",
  "VIOLATIONS": "Violations",
  "ISREQUIRED": "is required.",
  "MUSTBEATLEASTCHARACTERSINLENGTH": "must be at least {len} characters in length.",
  "ROUTES": "Routes",
  "NAME": "Name",
  "DRIVER": "Driver",
  "SUPERVISOR": "Supervisor",
  "EDITROUTE": "Edit Route",
  "ERROR": "Error",
  "CLOSE": "Close",
  "FILEISTOOLARGERMAXFILEIS": "File is too large, max file is {len}.",
  "TYPEERROR": "File extensions should be {len}.",
  "EXPENSES": "Expenses",
  "GASRATE": "Fuel Rate",
  "OILRATE": "Oil Rate",
  "IDLERATE": "Idling Rate",
  "TIRERATE": "Tire Rate",
  "ENTERRATE": "Enter rate",
  "INAED": "(In AED)",
  "VEHICLEPRICE": "Vehicle Price",
  "FINANCIAL": "Financial",
  "INSPECTION": "Inspection",
  "VEHICLEDEPRECIATION": "Vehicle Depreciation",
  "VEHICLEPERMIT": "Vehicle Permit",
  "WEARTEAR": "Wear/Tear",
  "COST": "Cost"
},
"ar": {
  "BUSES": "الحافلات",
  "MANAGEBUS": "إدارة الحافلات",
  "ADDNEWBUS": "إضافة ا حافلة جديدة",
  "BUSNUMBER": "رقم الحافلة",
  "MAKE": "الصنع",
  "MODEL": "النوع",
  "YEAR": "السنة",
  "PLATENUMBER": "رقم اللوحة",
  "SEATINGCAPACITY": "عدد المقاعد",
  "EXPIRATIONDATE": "تاريخ الإنتهاء",
  "DOCUMENTS": "الوثائق",
  "REGISTRATIONEXPIRATIONDATE": "تاريخ انتهاء تسجيل الحافلة",
  "LABEL": "الاسم",
  "EDITBUS": "تحرير الحافلة",
  "VIEW": "عرض",
  "LOADING": "جار التحميل...",
  "PICKADATE":"اختر تاريخا",
  "PICKAYEAR": "اختيار السنة",
  "DROPFILEHEREOR": "نزل الملف هنا أو",
  "CLICKTOUPLOAD": "اظغط للتحميل",
  "JPGPNGFILES": "ملفات PNG/JPG بحجم أقل من 400",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "REGISTRATION": " التسجيل ",
  "INSURANCE": "التامين ",
  "OTHER": "آخر",
  "DOCUMENTTYPE": "نوع الوثيقة",
  "NAME": "الاسم",
  "FILE": "الملف",
  "PREVIEW": "معاينة",
  "DELETEDOCUMENT": "حذف المستند",
  "TRIPS": " رحلات",
  "VIOLATIONS": "انتهاكات",
  "ISREQUIRED": ".مطلوب",
  "MUSTBEATLEASTCHARACTERSINLENGTH": ".يجب أن تكون على الأقل {len} حرفا",
  "ROUTES": "خطوط السير",
  "NAME": "الاسم",
  "DRIVER": "السائق",
  "SUPERVISOR": "المشرفة",
  "EDITBUS": "تحرير الحافلة",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "FILEISTOOLARGERMAXFILEIS": "ملحقات الملفات يجب أن تكون {len}.",
  "TYPEERROR": "ملحقات الملفات يجب أن تكون {len}.",
  "EDITROUTE": "تحرير خط السير",
  "EXPENSES": "نفقات",
  "GASRATE": "معدل استهلاك الوقود",
  "OILRATE": "معدل النفط",
  "IDLERATE": "معدل الوقت الضائع",
  "TIRERATE": "معدل الاطارات",
  "ENTERRATE": "أدخل معدل",
  "INAED": "(بالدرهم)",
  "VEHICLEPRICE": "سعر السيارة",
  "FINANCIAL": "الأمور المالية",
  "INSPECTION": "تفتيش",
  "VEHICLEDEPRECIATION": "استهلاك المركبات",
  "VEHICLEPERMIT": "تصريح المركبة",
  "WEARTEAR": "استهلاك ناتج عن الاستعمال ",
  "COST": "تكلفة"
  }
}
</i18n>
<template>
  <div class="form"  v-loading="loading" :element-loading-text="$t('LOADING')">
    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }">
    <wi-save slot="header" :form="['mainForm', 'expenseForm']" :title="$t('MANAGEBUS')" :data="{bus: this.bus}"></wi-save>
    <el-row>
      <el-col :span="10">

        <el-tabs type="border-card"  class="tabs"   v-bind:style="{ height: cardHeight + 'px' }">

          <el-form ref="mainForm" :model="bus" label-width="120px" label-position="top">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('BUSNUMBER')" prop="Label" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'blur'}">
                  <el-input v-model="bus.Label"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('REGISTRATIONEXPIRATIONDATE')" prop="RegistrationExpiration" :rules="{type:'date', required: true, message:$t('ISREQUIRED'), trigger:'blur,change'}">
                  <el-date-picker type="date" :placeholder="$t('PICKADATE')" :format="date_format" :picker-options="pickerOption" v-model="bus.RegistrationExpiration"   style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('PLATENUMBER')" prop="Plate" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'blur'}">
                  <el-input v-model="bus.Plate"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('SEATINGCAPACITY')" prop="MaxSeats" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'blur'}">
                  <el-input v-model="bus.MaxSeats"></el-input>
                </el-form-item>

              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
               <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item :label="$t('MODEL')" prop="Model" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'blur'}">
                     <el-input v-model="bus.Model"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('YEAR')" prop="Year" :rules="{type:'date',required: true, message:$t('ISREQUIRED'), trigger:'blur,change'}">
                      <el-date-picker type="year" :placeholder="$t('PICKAYEAR')" v-model="bus.Year" :picker-options="yearDisable"  style="width: 100%;"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('MAKE')" prop="Make" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'blur'}">
                  <el-input v-model="bus.Make"></el-input>
                </el-form-item>
              </el-col>
            </el-row>


          </el-form>
        </el-tabs>
      </el-col>
      <el-col :span="14">
        <el-tabs type="border-card" @tab-click="getTabData"  class="formTab"  v-bind:style="{ height: cardHeight + 'px' }">
        <el-tab-pane :label="$t('EXPENSES')">
          <el-form ref="expenseForm" :model="bus" label-width="120px" label-position="top" style="padding:15px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('VEHICLEPRICE') + ' ' + $t('INAED')" prop="Expenses.Price" :rules="{type: 'string', required: false, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Price" @change="priceVal = (bus.Expenses.Price !== '')">
                    </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('VEHICLEPERMIT') + ' ' + $t('INAED')" prop="Expenses.Permit" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Permit">
                      <template slot="append">/ Year</template>
                    </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('REGISTRATION') + ' ' + $t('COST') + ' ' + ' ' + $t('INAED')" prop="Expenses.Registration" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Registration">
                      <template slot="append">/ Year</template>
                    </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('INSURANCE') + ' ' + $t('INAED')" prop="Expenses.Insurance" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Insurance">
                      <template slot="append">/ Year</template>
                    </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('INSPECTION') + ' ' + ' ' + $t('COST') + ' ' + $t('INAED')" prop="Expenses.Inspection" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Inspection">
                      <template slot="append">/ Year</template>
                    </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('VEHICLEDEPRECIATION')" prop="Expenses.Depreciation" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Depreciation">
                      <template slot="append">/ %</template>
                    </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('DRIVER') + ' ' + $t('COST') + ' ' + $t('INAED')" prop="Expenses.Driver" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Driver">
                      <template slot="append">/ Month</template>
                    </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('SUPERVISOR') + ' ' + $t('COST') + ' ' + $t('INAED')" prop="Expenses.Supervisor" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Supervisor">
                      <template slot="append">/ Month</template>
                    </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FINANCIAL') + ' ' + $t('COST') + ' ' + $t('INAED')" prop="Expenses.Finance" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Finance">
                      <template slot="append">/ Month</template>
                    </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('WEARTEAR') + ' ' + $t('INAED')" prop="Expenses.Wear_Tear" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Wear_Tear">
                      <template slot="append">/ Km</template>
                    </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('GASRATE') + ' ' + $t('INAED')" prop="Expenses.Fuel" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Fuel">
                      <template slot="append">/ Km</template>
                    </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('OILRATE') + ' ' + $t('INAED')" prop="Expenses.Oil" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Oil">
                      <template slot="append">/ Km</template>
                    </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('TIRERATE') + ' ' + $t('INAED')" prop="Expenses.Tire" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Tire">
                      <template slot="append">/ Km</template>
                    </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('IDLERATE') + ' ' + $t('INAED')" prop="Expenses.Idling" :rules="{type: 'string', required: priceVal, message:$t('ISREQUIRED'), trigger:'blur'}">
                    <el-input type="number" :placeholder="$t('ENTERRATE')" v-model="bus.Expenses.Idling">
                      <template slot="append">/ Min</template>
                    </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
          <el-tab-pane :label="$t('DOCUMENTS')">
          <div style="padding:15px">
          <el-upload
            class="upload-docs"
            drag
            :before-upload="beforeUpload"
            :file-list="fileList"
            :on-success="fileUploaded"
            :data="{folder: 'bus'}"
            :with-credentials="true"
            :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
            :action="URL + 'media/upload/documents'"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{$t('DROPFILEHEREOR')}} <em>{{$t('CLICKTOUPLOAD')}}</em></div>
            <div class="el-upload__tip" slot="tip">{{$t('JPGPNGFILES')}}</div>
          </el-upload>
    </div>
    <el-row class="tab-table-margin">
  <el-table
      :data="bus.Documents"
      :height="cardHeight-118"
      style="width: 100%;">
      <el-table-column
        :label="$t('NAME')">
              <template slot-scope="props">
                  <el-select class="form-control" v-model="props.row.label"  :title="$t('DOCUMENTTYPE')">
                    <el-option :label="$t('REGISTRATION')" value="Registration"></el-option>
                    <el-option :label="$t('INSURANCE')" value="Insurance"></el-option>
                    <el-option :label="$t('OTHER')" value=""></el-option>
                </el-select>
              </template>
      </el-table-column>
      <el-table-column
        prop="file_name"
        :label="$t('File')">
      </el-table-column>
      <el-table-column :label="$t('PREVIEW')" width="100">
          <template slot-scope="scope">
              <el-button size="small" @click="openSlider(scope.row)"><i class="fa fa-sticky-note"></i> {{$t('VIEW')}}</el-button>
          </template>
      </el-table-column>
      <el-table-column width="100" align="right">
      <template slot-scope="props">
        <el-tooltip :content="$t('DELETEDOCUMENT')" placement="top">
          <el-button type="text" @click="props.row.deleted=!props.row.deleted"><i class="fa fa-2x" v-bind:class="[props.row.deleted ? 'fa-undo' : 'fa-remove']" ></i></el-button>
        </el-tooltip>
      </template>
      </el-table-column>
    </el-table>
    </el-row>
        <el-doc-dialog :visible.sync="dialogVisible" :document="document"></el-doc-dialog>
          </el-tab-pane>
          <el-tab-pane :label="$t('ROUTES')" name="route"  v-if="bus.BusID!=null">
            <el-row class="tab-table-margin">
              <el-table
        v-loading="loadingRoutes"
        :element-loading-text="$t('LOADING')"
        :data="routes"
        highlight-current-row
        :height="cardHeight"
        stripe
        style="width: 100%">
        <el-table-column
          :label="$t('NAME')"
          show-overflow-tooltip
          min-width="150"
          class="left"
        >

          <template slot-scope="scope">
            <el-tag style="display:block; text-align:center;"  v-bind:style="'background-color:' + scope.row.RouteColor">
              <el-button type="text" @click="$router.push({path:'/transportation/route/'+scope.row.TourID})" style="color:#fff; padding:0">{{scope.row.TourName}}</el-button>
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('DRIVER')"
          min-width="150"
          align="left"
          sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.DriverPhoto, 'driver')" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.DriverFullName_EN, NameAR: scope.row.DriverFullName_AR})}}
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('SUPERVISOR')"
          min-width="150"
          align="left"
          sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.MonitorPhoto, 'supervisor')" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.MonitorFullName_EN, NameAR: scope.row.MonitorFullName_AR})}}
          </template>
        </el-table-column>

        <el-table-column
          label=""
          min-width="40"
          align="right"
          class="actions">

          <template slot-scope="scope">
            <el-tooltip :content="$t('EDITROUTE')" placement="top">
              <el-button type="text" @click="$router.push({path:'/transportation/route/'+scope.row.TourID})"><i class="fa fa-pencil"></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
            </el-row>
          </el-tab-pane>
          <el-tab-pane :label="$t('VIOLATIONS')"  v-if="false">{{$t('VIOLATIONS')}}</el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    </el-card>

  <el-dialog
  :title="$t('ERROR')"
  v-model="error"
  size="tiny">

  <div class="el-alert el-alert--error">
    <i class="el-alert__icon el-icon-circle-cross is-big"></i>
    <div class="el-alert__content">
      <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in message" v-html="printError(messageError)"></span>
      </div>
   </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
  </span>
</el-dialog>

  </div>
</template>
<script>

  import Vue from 'vue'
  import DocDialog from '@/components/dialogs/Doc'
  import WiSave from '@/components/dialogs/Save'
  export default {
    components: {'el-doc-dialog': DocDialog, 'wi-save': WiSave},
    data () {
      return {
        bus: {BusID: null, Year: null, RegistrationExpiration: null, Documents: [], Expenses: {}},
        routes: [],
        loading: false,
        activeIndex: '',
        handleSelect: '',
        dialogVisible: false,
        dialogImageUrl: '',
        cardHeight: 0,
        date_format: 'dd/MM/yyyy',
        fileList: [],
        document: [],
        message: null,
        error: false,
        priceVal: false,
        loadingRoutes: false,
        pickerOption: {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        yearDisable: {
          disabledDate (time) {
            return time.getFullYear() - 1 >= new Date().getFullYear()
          }
        }
      }
    },
    mounted () {
      this.switchLanguage()
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.getBus()
    },
    watch: {
      priceVal (newVal, oldVal) {
        if (!newVal) this.$nextTick(function () { this.$refs.expenseForm.validate() })
      }
    },
    methods: {
      printError (message) {
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      getBus () {
        let self = this
        if (this.$route.params.id === 'create') return
        self.loading = true
        this.$http.get('/bus/' + this.$route.params.id).then(function (response) {
          self.bus = response.data
          self.bus.RegistrationExpiration = self.dateFormat(self.bus.RegistrationExpiration)
          self.bus.Expenses = JSON.parse(self.bus.Expenses)
          if (self.bus.Expenses.Price !== undefined && self.bus.Expenses.Price) self.priceVal = true
          self.bus.Year = self.dateFormat(self.bus.Year)
          self.loading = false
        }).catch(function (response) {})
      },
      onSubmit () {
        console.log('submit!')
      },
      handleRemove (file, fileList) {
        console.log(file, fileList)
      },
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      fileUploaded (response, file, fileList) {
        this.bus.Documents.push({label: '', file_name: response.file_name, deleted: false})
      },
      openSlider (bus) {
        Vue.set(this.document, 0, bus)
        this.dialogVisible = true
      },
      getRoute () {
        let self = this
        if (self.routes.length !== 0) return
        self.loadingRoutes = true
        this.$http.get('/route/assigned?BusID=' + self.bus.BusID)
          .then(function (response) {
            self.loadingRoutes = false
            self.routes = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getTabData (tab) {
        switch (tab.name) {
          case 'route':
            this.getRoute()
            break
        }
      },
      beforeUpload (file) {
        const isJPG = file.type.split('/')[0] === 'image' || file.type.split('/')[1] === 'pdf' || file.type.split('/')[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type.split('/')[0] === 'text'
        const isLt2KB = file.size / 1024 < 400
        this.message = {}
        if (!isJPG) {
          this.message['type'] = ' TYPEERROR png,gif,jpeg,jpg,pdf,doc,docx,txt'
        }
        if (!isLt2KB) {
          this.message['size'] = ' FILEISTOOLARGERMAXFILEIS 400KB'
        }
        if (Object.keys(this.message).length !== 0) this.error = true
        return isJPG && isLt2KB
      }
    }
  }
</script>

<style>
.upload-docs   .el-upload{width:100% !important;}
.upload-docs  .el-upload-dragger{width:auto !important;}
</style>




// WEBPACK FOOTER //
// BusManage.vue?314eead0